export const handleError = (response: any) => {
  if (response.message) return response.message;
  else return response.errors[0].message;
}